module.exports = __webpack_public_path__ + "static/media/patient3.c16f2ea8.jpg";